import { StCryptographyProvider } from "./StCryptographyProvider";
import { StCryptographyProviderFactory } from "./StCryptographyProviderFactory";
import { StCryptographyType } from "./StCryptographyType";

export class StCryptoSymmetricOperator {
  private static instance: StCryptoSymmetricOperator | null = null;
  private cryptographyProvider: StCryptographyProvider;

  private constructor() {
    this.cryptographyProvider = StCryptographyProviderFactory.create(
      StCryptographyType.SYMMETRIC
    );
  }

  static getInstance(): StCryptoSymmetricOperator {
    if (!StCryptoSymmetricOperator.instance) {
      StCryptoSymmetricOperator.instance = new StCryptoSymmetricOperator();
    }
    return StCryptoSymmetricOperator.instance;
  }

  async encrypt(data: string, publicKey: string): Promise<string> {
    return this.cryptographyProvider.encrypt(data, publicKey);
  }

  async decrypt(encryptedData: string, privateKey: string): Promise<string> {
    return this.cryptographyProvider.decrypt(encryptedData, privateKey);
  }
}
